import { useCatalogPropsStore } from "@core-ui/stores/CatalogPropsStore/CatalogPropsStore.provider";
import {
	updateCatalogReportSettings,
	useCatalogReportSettingsStore,
} from "@ext/catalog/report/logic/catalogReportSettingsStore";
import {
	DEFAULT_VIEW_SETTINGS,
	getDisplayPatch,
	type ViewSettings,
} from "@ext/markdown/elements/view/models/ViewSettings";
import type { Display } from "@ext/properties/models/display";
import { useCallback } from "react";

/** Report settings live on the device, one set per catalog, and never reach the repository. */
export const useCatalogReportSettings = () => {
	const catalogName = useCatalogPropsStore((state) => state.data?.name);
	const settings = useCatalogReportSettingsStore((state) => state.byCatalog[catalogName] ?? DEFAULT_VIEW_SETTINGS);

	const updateSettings = useCallback(
		(patch: Partial<ViewSettings>) => updateCatalogReportSettings(catalogName, patch),
		[catalogName],
	);

	const updateDisplay = useCallback(
		(display: Display) => updateSettings(getDisplayPatch(settings, display)),
		[settings, updateSettings],
	);

	return { settings, updateSettings, updateDisplay };
};
